module.exports = __webpack_public_path__ + "img/support.7688b26a.svg";